export function getDistValue(key, arr) {
  let val = ''
  if (Array.isArray(arr)) {
    arr.forEach(e => {
      if (e.key + '' === key + '') {
        val = e.value
      }
    })
  }
  return val
}

